import formatRelativeDatetimes from 'lib/toolkit/behaviors/format_relative_datetimes.js'

# Ignore mutations if they target only elements of one of these classes
observerTargetClassBlacklist = [
  "textoverlay",
  "js-localized-datetime"
]

# Some locale codes are different between Localize.js and Moment.js
localeMap = {
  "en-GB": "en-gb",
  "zh": "zh-cn"
}

# monthYear & monthDay will translate month names but are not fully localized formats.
formatMap = {
  dateshorthand: "l",
  date: "ll",
  time: "LT",
  datetime: "lll",
  monthYear: "MMMM YYYY"
  monthDay: "MMM D"
}
observer = null

isBlacklisted = (mutationList) ->
  classNames = _.uniq(_.map(mutationList, (mutation) -> mutation.target.className))
  classNames.length == 1 && !!~observerTargetClassBlacklist.indexOf(classNames[0])

formatDatetimes = (locale, mutationList) ->
  return if isBlacklisted(mutationList)

  formatRelativeDatetimes(locale)

  $("[data-behavior='localized-datetime']").each((_, el) ->
    return if el.getAttribute("data-localized-datetime") == locale

    if el.hasAttribute("data-formatted-date-range")
      setDateRange(el, locale)
    else
      setDate(el, locale)

    el.setAttribute("data-localized-datetime", locale)
  )

setDate = (el, locale) ->
  timestamp  = el.getAttribute("data-timestamp")

  el.innerText = moment(timestamp).parseZone().locale(localeMap[locale] || locale).format(getFormat(el))

setDateRange = (el, locale) ->
  if locale == "en"
    el.innerText = el.getAttribute("data-formatted-date-range")
  else
    startDate = el.getAttribute("data-timestamp-from")
    endDate   = el.getAttribute("data-timestamp-to")
    format    = getFormat(el)

    formattedStartDate = moment(startDate).parseZone().locale(localeMap[locale] || locale).format(format)
    formattedEndDate   = moment(endDate).parseZone().locale(localeMap[locale] || locale).format(format)
    el.innerText = if formattedStartDate == formattedEndDate then "#{formattedStartDate}" else "#{formattedStartDate} - #{formattedEndDate}"

getFormat = (el) ->
  formatType = el.getAttribute("data-format-type")
  formatMap[formatType]

startObserver = (locale) ->
  callback = formatDatetimes.bind(this, locale)
  callback()
  observer = new MutationObserver(callback)
  observer.observe(document.getElementById("page-container"), { childList: true, subtree: true })

setDatetimeLocale = (locale) ->
  if observer
    observer.disconnect()
    observer = null
  startObserver(locale)

export default setDatetimeLocale



// WEBPACK FOOTER //
// ./app/javascript/lib/toolkit/behaviors/format_datetimes.js.coffee